import React from 'react'
import { unitPrice } from '../../../../../../utils/product'

export default (props) => <span {...props}>{unitPrice(props.money)}</span>